import { SVGAttributes } from 'react';

export const TooltipSprite = (props?: SVGAttributes<SVGPathElement>) => (
  <path d="M34-57H-34A16,16,0,0,0-50-41V27A16,16,0,0,0-34,43h24L0,57,10,43H34A16,16,0,0,0,50,27V-41A16,16,0,0,0,34-57Z" opacity="0.7" {...props} />
);
